import * as React from 'react';

import ToolCard from './ToolCard';

import '../Blocks/Browser.css'

class ToolCardVisual extends React.Component {
    public render() {
        return (
            <div className="Browser__content-grtoolId">
                <ToolCard
                    toolId="0"
                    name="PLACEHOLDER"
                    time="30"
                    participants="2"
                    />
                <ToolCard
                    toolId="1"
                    name="PLACEHOLDER PLAC"
                    time="30-60"
                    participants="2+"
                    />

                <ToolCard
                    toolId="2"
                    name="5 Whys"
                    time="30-60"
                    participants="2+"

                    shortDescription="5 Whys is a lightweight iterative technique used to explore the cause-and-effect relationships underlying a particular problem. Quickly uncover blindspots, tease out assumptions, and dectoolIde what part of a problem space you're going to tackle."
                    source="https://www.isixsigma.com/tools-temp/blablahblah"                    
                    />
                <ToolCard
                    toolId="3"
                    name="I am the most amazing tool in the history of this nation and really don't know what else to write to break it"
                    time="30-60"
                    participants="2+"

                    shortDescription="5 Whys is a lightweight iterative technique used to explore the cause-and-effect relationships underlying a particular problem. Quickly uncover blindspots, tease out assumptions, and dectoolIde what part of a problem space you're going to tackle."
                    source="https://www.isixsigma.com/tools-temp/blablahblah"
                    
                    />
                <ToolCard
                    toolId="4"
                    name="I Am Not Amazing"
                    time="30-60 maybe 80"
                    participants="2+"

                    shortDescription="5 Whys is a lightweight iterative technique used to explore the cause-and-effect relationships underlying a particular problem. Quickly uncover blindspots, tease out assumptions, and dectoolIde what part of a problem space you're going to tackle."
                    source="https://www.isixsigma.com/tools-temp/blablahblah"                    
                    />
                <ToolCard
                    toolId="5"
                    name="I Am Not Amazing"
                    time="30-60"
                    participants="20-200 toolIdK"

                    shortDescription="5 Whys is a lightweight iterative technique used to explore the cause-and-effect relationships underlying a particular problem. Quickly uncover blindspots, tease out assumptions, and dectoolIde what part of a problem space you're going to tackle."
                    source="https://www.isixsigma.com/tools-temp/blablahblah"
                    />
            </div>
        );
    }
};

export default ToolCardVisual;


// WEBPACK FOOTER //
// ./src/App/Elements/ToolCard.visual.tsx